import {useQuery} from "react-query";
import spaceService from "../../services/SpaceService";
import {SearchSpaceRequest} from "../../models/drive";

export default function useSpaces(request?: SearchSpaceRequest) {
   return useQuery(['spaces', request], () => spaceService.search(request));
}